import React from 'react'

const EmailCollector = () => {
  return (
    <div>EmailCollector</div>
  )
}

export default EmailCollector